import * as React from "react";
import Seo from "@components/seo";
import Layout from "@layout";
import Header from "@layout/header/header-one";
import Footer from "@layout/footer/footer-one";
import SectionOne from '@containers/Tutorials/ATIS2025'
import Banner from "@components/banners/ECML2023";

const QML = ({ pageContext, location }) => {
	return (
		<Layout location={location}>
			<Seo title="Advances in Quantum Machine Learning" />
			<Header />
			<Banner
				pageContext={pageContext}
				location={location}
				title="Advances in Quantum Machine Learning"
			/>
			<main className="site-wrapper-reveal">
				<SectionOne />
			</main>
			<Footer />
		</Layout>
	)
}

export default QML
